import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { Edit, LucideAngularModule, Plus } from 'lucide-angular';
import { PagedEntities } from '@app/shared/abstract/paged-entities';
import { UserModel } from '../shared/user.model';
import { RouteParams } from '@app/shared/abstract/route-params';
import { Column } from '@app/partials/datatable/data-table/column';
import { DataTableComponent } from '@app/partials/datatable/data-table/data-table.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-index11',
  imports: [DataTableComponent, LucideAngularModule, RouterLink],
  templateUrl: './users-index.component.html',
  styleUrl: './users-index.component.css',
})
export class UsersIndexComponent implements OnInit {
  constructor(private service: UserService) {}

  protected readonly PlusIcon = Plus;
  protected readonly EditIcon = Edit;

  protected usersPage?: PagedEntities<UserModel>;

  routeParams = new RouteParams({
    pageNum: 1,
  });

  tableColumns: Column<UserModel>[] = [
    { field: 'name', header: 'Name', sortable: true },
    { field: 'email', header: 'Email' },
    { field: 'roles', header: 'Roles' },
    {
      field: 'created_at',
      header: 'Created At',
      sortable: true
    },
  ];

  rowActions = [{ icon: this.EditIcon, type: 'link', routerLink: (item: UserModel) => ['/users', item.id, 'edit'] }];

  loadData() {
    this.service.getPage(this.routeParams).subscribe((res) => {
      this.usersPage = res;
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  handleRoute(params: RouteParams) {
    this.routeParams.sort = params.sort;
    this.routeParams.pageNum = params.pageNum;
    this.routeParams.pageSize = params.pageSize;
    this.loadData();
  }
}
